<template>
  <div class="hd_not_box">
    <img :src="not_data" alt="" />
    <div class="text_box">
      当前页面需要消耗慧豆解锁，若您已获取足够的慧豆，可点击下方刷新按钮重新请求
    </div>
    <div class="link_text" @click="goLinkHd">
      <span>查看如何获取慧豆</span><img src="../../assets/image/right_img.png" alt="" />
    </div>
    <div class="btn_box" @click="reloading">刷新页面</div>
  </div>
</template>
<script>
import mixins from '@/mixins/index.js';
export default {
  name: 'notHd',
  mixins: [mixins],
  data() {
    return {
      not_data: require('../../assets/image/notData.png')
    };
  },
  filters: {},
  created() {},
  mounted() {},
  methods: {
    goLinkHd: function () {
      window.location.href = window.config.hdTips;
    },
    reloading: function () {
      this.$router.go(0);
    }
  }
};
</script>
<style lang="less" scoped>
.hd_not_box {
  padding-top: 70px;
  width: 100%;
  text-align: center;
  margin: 0 auto;
  img {
    width: 180px;
    height: 120px;
    margin: 0 auto;
    margin-bottom: 11px;
  }
  .text_box {
    width: 268px;
    margin: 0 auto;
    font-size: 14px;
    color: #b8bbca;
    margin-bottom: 56px;
  }
  .link_text {
    font-size: 14px;
    color: #286df7;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    img {
      width: 12px;
      height: 12px;
      margin: 0;
      margin-left: 8px;
    }
  }
  .btn_box {
    width: 200px;
    padding: 7px 0;
    border-radius: 6px;
    background: #2568eb;
    text-align: center;
    font-size: 14px;
    color: #fff;
    margin: 0 auto;
  }
}
</style>
